import SearchCategories from './SearchCategories';

export default SearchCategories;
